export default {
  line2Title: "ВыбериТЕ сообщество, в которое хоТИТЕ погрузиться:".toUpperCase(),
  line3Title: "ВЫБЕРИТЕ О ЧЕМ ВЫ ХОТИТЕ УЗНАТЬ БОЛЬШЕ:".toUpperCase(),

  english: "ангоговорящее".toUpperCase(),
  russian: "русскоговорящее".toUpperCase(),
  chinese: "китайское".toUpperCase(),
  spanish: "испанское".toUpperCase(),
  french: "французкое".toUpperCase(),

  chat: "чаты".toUpperCase(),
  markets: "маркеты".toUpperCase(),
  forums: "форумы".toUpperCase(),
  "top sellers": "топ продавцы".toUpperCase(),
  essentials: "основное".toUpperCase(),
  others: "прочее".toUpperCase(),
}
